import { Loadable } from 'foundations-components/transitional/utils/Loadable';
export const AsyncUsageLimitCounter = Loadable({
  loader: () => import( /* webpackChunkName: "external" */'ui-addon-upgrades/ums/UIUsageLimitCounter'),
  LoadingComponent: () => null
});